import { useEffect, useState } from "react";
import BuilderModal from "../../../Layouts/Modal/BuilderModal";
import TableTreeModal from "../TableTreeModal";
import ButtonActionIcon from "../ButtonActionIcon";
import Input from "../../FormComponents/Input";
import Button from "../../FormComponents/Button";
import Label from "../../FormComponents/Label";
import MaterialIcon from "../MaterialIcon";

const PreFilterDefaultSort = ({ tableObj, blockType, defaultSort, setSortColumns, tableId, folderIds }) => {
  const [isModalOpen, setIsModalOpen] = useState(null);
  const addSortField = (data) => {
    let newArray = [];
    if (!defaultSort) {
      defaultSort = [];
      newArray = [];
    } else {
      newArray = JSON.parse(JSON.stringify(defaultSort));
    }
    newArray.push({
      key: data.id,
      order: "ASC",
      missing_date: false
    });

    setSortColumns(newArray);
    setIsModalOpen(false);
  };

  const deleteSortField = (index) => {
    const selectedCopy = JSON.parse(JSON.stringify(defaultSort));
    selectedCopy.splice(index, 1);
    setSortColumns(selectedCopy);
  };
  const updateSortColumn = (index, type, value) => {
    let copySort = JSON.parse(JSON.stringify(defaultSort));
    copySort[index][type] = value;
    setSortColumns(copySort);
  };
  return (
    <>
      {defaultSort && defaultSort.length === 0 && (
        <div className="recordview_summary_container d_flex justify_center">
          <div className="d_flex gap_3 p_3 align_center">
            <MaterialIcon name="filter_list" />
            <span>No pre-sorting column added</span>
            <Button
              variant="secondary"
              style={{ width: "24px", height: "24px" }}
              size="small"
              onClick={() => setIsModalOpen(true)}
            >
              <MaterialIcon name="add" style={{ fontSize: "12px" }} />
            </Button>
          </div>
        </div>
      )}
      {defaultSort && defaultSort.length > 0 && (
        <div className="position_relative">
          <Label className="position_absolute font_weight_semibold" style={{ top: "-8px", left: "14px" }}>
            Pre Sort field (ascending order by default)
          </Label>
          <div className="recordview_summary_container horizontal_scroll">
            {defaultSort.map((sort, index) => (
              <div className="recordview_summary_card d_flex" key={index}>
                <span>
                  {blockType === "rdbms" ? tableObj[sort.key]?.name : tableObj[sort.key]?.prefix} |{" "}
                  {tableObj[sort.key]?.display}
                </span>
                <span className="ml_5 d_flex gap_3">
                  <SingleSortRenderer
                    index={index}
                    sort={sort}
                    updateSortColumn={updateSortColumn}
                    type={tableObj[sort.key]?.field_type}
                  />
                  <ButtonActionIcon type="delete" size="xsm" onClick={() => deleteSortField(index)} />
                </span>
              </div>
            ))}
          </div>
          <Button
            variant="secondary"
            size="small"
            onClick={() => setIsModalOpen(true)}
            className="position_absolute font_weight_semibold"
            style={{ top: "-8px", right: "22px" }}
          >
            +
          </Button>
        </div>
      )}
      <BuilderModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        modalName={isModalOpen === "add" ? "Add form field" : "Edit form field"}
      >
        <TableTreeModal callbackFunction={addSortField} tableType={blockType} tableId={tableId} folderId={folderIds} />
      </BuilderModal>
    </>
  );
};

const SingleSortRenderer = ({ index, sort, updateSortColumn, type }) => {
  const [sortData, setSortData] = useState(sort);

  useEffect(() => {
    setSortData(sort);
  }, [sort]);
  return (
    <div className="d_flex align_center gap_2">
      {type === "date" && (
        <>
          <Input
            type="checkbox"
            id={`miss-date-${index}`}
            label="Missing Date"
            checked={sortData.missing_date || false}
            onChange={(e) => {
              const newOrder = e.target.checked;
              setSortData({ ...sortData, missing_date: newOrder });
              updateSortColumn(index, "missing_date", newOrder);
            }}
          />
        </>
      )}
      <Input
        type="checkbox"
        label="DESC"
        id={`DESC-${index}`}
        value="DESC"
        checked={sortData?.order === "DESC"}
        onChange={(e) => {
          const newOrder = e.target.checked ? "DESC" : "ASC";
          setSortData({ ...sortData, order: newOrder });
          updateSortColumn(index, "order", newOrder);
        }}
      />
    </div>
  );
};

export default PreFilterDefaultSort;
